// Deterministic avatar color ramp + name hash. Lives in common/lib so both
// modules/ (contacts, tasks via modules/shared/colors re-export) and features/
// (notification toasts) can share one copy — features may not import modules/
// under the one-way import rule.

// Avatar palette — 6 ramps from contacts spec §9. Pairs are tuned for gentle
// backgrounds with sufficient text contrast (WCAG AA on bg).
export const AVATAR_RAMP: Array<{ bg: string; text: string }> = [
  { bg: '#E6F1FB', text: '#185FA5' }, // blue
  { bg: '#E1F5EE', text: '#0F6E56' }, // teal
  { bg: '#EEEDFE', text: '#534AB7' }, // purple
  { bg: '#FAECE7', text: '#993C1D' }, // coral
  { bg: '#FAEEDA', text: '#854F0B' }, // amber
  { bg: '#FBEAF0', text: '#993556' }, // pink
];

/**
 * DJB2-style hash for even distribution across the ramp.
 */
export function nameHash(name: string): number {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = ((hash << 5) - hash + name.charCodeAt(i)) | 0;
  }
  return hash >>> 0;
}

export function getAvatarColorPair(name: string): { bg: string; text: string } {
  if (!name) return AVATAR_RAMP[0];
  return AVATAR_RAMP[nameHash(name) % AVATAR_RAMP.length];
}
